
import * as api from "../../../api"; 


  
export const checkLeadManagerLoginStatus = (post) => async (dispatch)=>{
    try {
        const {data } = await api.checkLeadManagerLoginStatus(post);
       
        
        
        return data 
     } catch (error) {
        // dispatch({
        //     type: "LOGINLEAD",
            
        //     payload:null
        //   });  
    }
}

